import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'


@Component({
    selector: 'eb-modal',
    templateUrl: './eb-modal.component.html',
    styleUrls: ['./eb-modal.component.scss'],
    standalone: false
})
export class EbModalComponent implements OnInit {
  @Input() title: string
  @Input() loaded$: Observable<boolean>
  @Input() modalIsOpen = false
  @Input() withoutClose = false
  description: string
  constructor(protected modalService: LaunchDialogService) {}
  closeModal(): void {
    this.modalService.closeDialog('Close')
  }
  ngOnInit(): void {
    this.modalService.data$.subscribe(dialogData => {
      this.title = dialogData.title
      this.loaded$ = dialogData.loaded$
      this.description = dialogData.description
      this.modalIsOpen = dialogData.modalIsOpen
      this.withoutClose = dialogData.withoutClose
    })
  }
}
